<template>
    <div>
        <div class='mcf-page-background'></div>
        <div class="mcf-page-editor">
            <div class="mcf-page-editor-form">
                <div class="mcf-page-editor-header">
                    <label>Gestion des stocks</label>
                </div>
                <div class="mcf-page-editor-menu">
                    <button @click="bt_save">
                        <i class="fa fa-save"></i>
                        <label>Enregistrer</label>
                    </button>
                    <button @click="bt_cancel">
                        <i class="fa fa-close"></i>
                        <label>Annuler</label>
                    </button>
                </div>
                <div class="mcf-page-editor-content">
                    <div class="mcf-page-editor-title">
                        <label><i class='fa fa-circle-info'></i> Informations générales</label>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-text">
                            <label>Date de mouvement</label>
                            <input type="date" v-model="o.date_movement" placeholder="">
                        </div>
                        <div class="mcf-page-editor-column-text" v-if="o.direction=='in'">
                            <label>Quantité à entrer</label>
                            <input type="number" v-model="o.qty_in" placeholder="">
                        </div>
                        <div class="mcf-page-editor-column-text" v-if="o.direction=='out'">
                            <label>Quantité à sortir</label>
                            <input type="number" v-model="o.qty_out" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line">
                        <div class="mcf-page-editor-column-text">
                            <label>Commentaire</label>
                            <input type="text" v-model="o.label" placeholder="">
                        </div>
                    </div>
                    <div class="mcf-page-editor-line-2">
                        <div class="mcf-page-editor-column-select">
                            <label>Localité</label>
                            <select v-model="o.locality">
                                <option value="STORE">Magasin</option>
                                <option value="WEB">Boutique en ligne</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import {DateTime} from "luxon";

export default {
    props:{
        account:Object,
        movement:Object,
        cancel:Function,
        save:Function
    },
    data(){
        return {
            o: this.movement
        };
    },
    created() {
        
    },
    methods:{
        bt_cancel:function(){
            this.cancel();
        },
        bt_save:function(){
            delete this.o.direction;
            this.save(this.o);
        }
    }
}
</script>